import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import PublicLayout from "@/components/public/PublicLayout";
import { pickLang, t } from "@/i18n/booking";

// Política de privacidad (doc="privacy") y aviso legal (doc="notice") de la instalación: el texto
// propio de la empresa o el texto por defecto con los datos de su perfil (backend/legal.py).
// El HTML llega ya escapado del servidor.
export default function LegalPage({ doc }) {
  const location = useLocation();
  const lang = pickLang(location.search);
  const [page, setPage] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get(`/public/legal/${doc}`, { params: { lang } })
      .then(({ data }) => alive && setPage(data))
      .catch(() => alive && setPage({ html: "" }));
    return () => {
      alive = false;
    };
  }, [doc, lang]);
  const title = t(lang, doc === "privacy" ? "privacy_title" : "notice_title");
  return (
    <PublicLayout lang={lang}>
      {() => (
        <article className="max-w-3xl bg-white border border-[#DCD8D0] rounded-xl p-8 space-y-4" data-testid={`legal-${doc}`}>
          <h1 className="font-display text-3xl font-bold text-[#1A1A1A]">{title}</h1>
          {page?.text_lang === "es" && lang !== "es" && t(lang, "legal_spanish_only") && (
            <p className="text-sm text-[#5C5C5C]">{t(lang, "legal_spanish_only")}</p>
          )}
          {!page && <p className="text-[#5C5C5C]">…</p>}
          <div
            className="text-sm leading-relaxed text-[#3A3A3A] [&_h2]:font-display [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-[#1A1A1A] [&_h2]:mt-6 [&_p]:mt-2 [&_ul]:mt-2 [&_ul]:list-disc [&_ul]:pl-5 [&_li]:mt-1"
            dangerouslySetInnerHTML={{ __html: page?.html || "" }}
          />
        </article>
      )}
    </PublicLayout>
  );
}
